import { IconMaximize, IconMaximizeOff } from "@tabler/icons-react"

import { Button } from "../../Button"
import { Tooltip } from "../../Tooltip"
import { LE_TableInstance } from "../types"

const TOGGLE_FULLSCREEN_BUTTON_ID_SUFFIX = "toggle-fullscreen-button"

export function ToggleFullscreenButton<T extends Record<string, any> = object>({
  table,
}: {
  table: LE_TableInstance<T>
}) {
  const { isFullscreen } = table.getState()

  return (
    <Tooltip content="Toggle fullscreen">
      <Button
        id={table.getElementId(TOGGLE_FULLSCREEN_BUTTON_ID_SUFFIX)}
        variant="neutral"
        iconOnly
        icon={isFullscreen ? IconMaximizeOff : IconMaximize}
        onClick={() => table.setIsFullscreen((v) => !v)}
        aria-label="toggle fullscreen"
      />
    </Tooltip>
  )
}
